import { ColorCardT } from '@components/Organisms/ColorCardList/types';
import { FC } from 'react';
import { StyledColorCard } from '@components/Organisms/ColorCardList/styled/StyledColorCard';

export const ColorCard: FC<ColorCardT> = ({ title, color, description }) => {
  return (
    <StyledColorCard className={`background-${color}`}>
      <h3>{title}</h3>
      <p>{description}</p>
    </StyledColorCard>
  );
};
